import type { ComponentPropsWithoutRef, ElementType, ReactNode } from 'react';

import { type ClassValue, clsxm } from '@vs-shop/utils';

import { TouchTarget } from '../touchTarget';

export type IconTouchableProps<T extends ElementType = 'button'> = {
  children: ReactNode;
  as?: T;
  className?: ClassValue;
} & Omit<ComponentPropsWithoutRef<T>, 'children' | 'className'>;

export function IconTouchable<T extends ElementType = 'button'>({
  children,
  as,
  className,
  ...rest
}: IconTouchableProps<T>) {
  const Component = as ?? 'button';

  return (
    <Component
      data-slot="icon-touchable"
      className={clsxm('relative flex items-center', className)}
      {...rest}
    >
      <TouchTarget>{children}</TouchTarget>
    </Component>
  );
}
